export const APP_STATES = {
  MAINTENANCE: 'maintenance'
};
